import React from 'react'
import { useFormContext } from 'react-hook-form'

import { required } from './Fields/config'
import RHFDatePickerInput from './Fields/RHFDatePickerInput'
import Input from './Fields/RHFInput'
import TextArea from './Fields/RHFTextArea'
import { useDefaultDatePickerMonthYear } from './Hooks/useDefaultDates'
import type { CreateNoteItemViewModel } from '../Create/models'
import type { PatchNoteItemViewModel } from '../Edit/models'

import Group from 'components/utils/Group'

interface Props {
  tripId: string
}

function NoteFields({ tripId }: Props) {
  const { register, watch } = useFormContext<
    CreateNoteItemViewModel | PatchNoteItemViewModel
  >()

  const { defaultMonth, defaultYear } = useDefaultDatePickerMonthYear({
    tripId,
  })

  const isSectionHeaderSelected = !!watch('isSectionHeader')

  return (
    <>
      <Input
        {...register('title', {
          required: isSectionHeaderSelected ? required : undefined,
        })}
        required={isSectionHeaderSelected}
        label="Title"
        placeholder="Add Title"
      />

      <TextArea
        {...register('notes', { required })}
        required
        label="Note"
        placeholder="Add note here"
        resize="vertical"
        rows={4}
      />
      <Group direction="vertical" horizontalAlign="stretch" gap={16}>
        <RHFDatePickerInput
          name="startDate"
          label="Date"
          required={isSectionHeaderSelected}
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
          placeholder="Select date"
        />
      </Group>
    </>
  )
}

export default NoteFields
